<ng-template #rightAppBar>
  <div class="mui-hero__app-bar--right">
    <ng-content></ng-content>
  </div>
</ng-template>
